/*
 * This file is generated by icons/template.js
 */
const SvgFb = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 33" {...props}>
		<g clipPath="url(#fb_svg__a)">
			<path
				fill="currentColor"
				d="M32 16.031c0-8.836-7.163-16-16-16s-16 7.164-16 16c0 7.986 5.85 14.606 13.5 15.806v-11.18H9.438V16.03H13.5v-3.525c0-4.01 2.389-6.225 6.043-6.225 1.75 0 3.582.313 3.582.313v3.937h-2.017c-1.988 0-2.608 1.234-2.608 2.5v3h4.438l-.71 4.625H18.5v11.18c7.65-1.2 13.5-7.819 13.5-15.805"
			/>
		</g>
		<defs>
			<clipPath id="fb_svg__a">
				<path fill="#fff" d="M0 .031h32v32H0z" />
			</clipPath>
		</defs>
	</svg>
);
SvgFb.displayName = 'iconFb';
export default SvgFb;
